import React from 'react';
import Modal from '../Modal';
import { s, sp } from './clientesEstilos';

export default function ProrrateoModal({ abierto, onCerrar, clienteProrrateo, resultProrrateo, calculando, calcularProrrateo }) {
  return (
    <Modal abierto={abierto} onCerrar={onCerrar} titulo="Calcular Prorrateo Primer Mes">
      {clienteProrrateo && (
        <div>
          <div style={sp.clienteInfo}>
            <div style={sp.clienteNombre}>{clienteProrrateo.nombre}</div>
            <div style={sp.clienteDetalle}>{clienteProrrateo.plan_nombre || 'Sin plan asignado'}</div>
          </div>

          {!clienteProrrateo.fecha_instalacion ? (
            <div style={sp.aviso}>
              ⚠️ Este cliente no tiene fecha de instalación registrada.<br/>
              <strong>Edítalo primero</strong> para agregar la fecha de instalación.
            </div>
          ) : (
            <>
              <div style={sp.infoBox}>
                <div style={sp.infoFila}>
                  <span>Fecha de instalación:</span>
                  <strong>{new Date(clienteProrrateo.fecha_instalacion).toLocaleDateString('es-CO')}</strong>
                </div>
                <div style={sp.infoFila}>
                  <span>Plan mensual:</span>
                  <strong>{clienteProrrateo.precio_mensual ? new Intl.NumberFormat('es-CO',{style:'currency',currency:'COP',minimumFractionDigits:0}).format(clienteProrrateo.precio_mensual) : '—'}</strong>
                </div>
              </div>

              {!resultProrrateo ? (
                <p style={sp.texto}>
                  El sistema calculará automáticamente el cobro proporcional del primer mes según los días transcurridos desde la fecha de instalación hasta el fin del mes actual.
                </p>
              ) : (
                <div style={sp.resultado}>
                  <div style={sp.resultadoTitulo}>✅ Cálculo de prorrateo</div>
                  <div style={sp.resultadoFila}>
                    <span>Días del mes:</span><span>{resultProrrateo.dias_del_mes}</span>
                  </div>
                  <div style={sp.resultadoFila}>
                    <span>Días cobrados:</span><span>{resultProrrateo.dias_cobrados}</span>
                  </div>
                  <div style={sp.resultadoFila}>
                    <span>Valor plan completo:</span><span>{new Intl.NumberFormat('es-CO',{style:'currency',currency:'COP',minimumFractionDigits:0}).format(resultProrrateo.monto_original)}</span>
                  </div>
                  <div style={{ ...sp.resultadoFila, ...sp.resultadoTotal }}>
                    <span>💰 Monto a cobrar:</span>
                    <span style={{ color:'#10B981', fontSize:'20px', fontWeight:'800' }}>
                      {new Intl.NumberFormat('es-CO',{style:'currency',currency:'COP',minimumFractionDigits:0}).format(resultProrrateo.monto_prorrateo)}
                    </span>
                  </div>
                  <p style={sp.textoSub}>El cobro ya fue creado en Cartera como pendiente. Puedes ir a registrar el pago desde allí.</p>
                </div>
              )}
            </>
          )}

          <div style={s.modalFooter}>
            <button style={s.btnSec} onClick={onCerrar}>Cerrar</button>
            {clienteProrrateo.fecha_instalacion && !resultProrrateo && (
              <button style={s.btnPrimario} onClick={calcularProrrateo} disabled={calculando}>
                {calculando ? 'Calculando...' : '⅟ Calcular y crear cobro'}
              </button>
            )}
          </div>
        </div>
      )}
    </Modal>
  );
}
